import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import _isNil from 'lodash/isNil';
import { updateSiteConstant } from '../../store/reducer';
import { useState } from 'react';

export const useFetchSiteConstant = () => {
  const dispatch = useDispatch();

  const { commonDataReducer } = useSelector((state: RootState) => state);
  const { siteConstant = {} } = commonDataReducer;

  const [isLoading, setIsLoading] = useState(false);

  //   const pathName = window.location.pathname.split('/')[1];

  const handleGetSiteConstantsApi = async (currentLanguage = 'en') => {
    const urlsToAvoid: string[] = [];

    // const fileName = constantFileNameBasedOnPathName[pathName] ?? pathName;

    const urls = ['common', 'dashboard', 'orders', 'customers', 'profile', 'login'].filter(
      (url) => !urlsToAvoid.includes(url)
    );

    const promises = urls.map((url) =>
      fetch(`/assets/languageJson/${currentLanguage}/constants/${url}.json`)
    );

    let newSitConstant = { ...siteConstant };

    setIsLoading(true);

    Promise.all(promises).then((responses) => {
      responses.forEach((response, index) => {
        if (!_isNil(response.ok)) {
          response
            .json()
            .then((data) => {
              newSitConstant = {
                ...newSitConstant,
                [urls[index]]: data,
              };

              if (index === promises.length - 1) {
                dispatch(updateSiteConstant({ data: newSitConstant }));
                setIsLoading(false);
              }
            })
            .catch((error) => {
              if (error instanceof Error) {
                //eslint-disable-next-line
                console.log('Error parsing JSON:', error.message);

                handleGetSiteConstantsApi('en');
              }
            });
        } else {
          //eslint-disable-next-line
          console.log('Error fetching data:', response.status);

          setIsLoading(false);
        }
      });
    });
  };

  return {
    isLoading,
    handleGetSiteConstantsApi,
  };
};
